import { useState } from 'react';
import { Link } from 'react-router-dom';
import { sendContactMessage } from '../API';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    company: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((current) => ({
      ...current,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await sendContactMessage(formData);
      setSuccess(response.message);
      setFormData({ name: '', email: '', message: '', company: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container page-container">
      <article className="page-card legal-page">
        <header className="page-card-header">
          <p className="page-eyebrow">Contact</p>
          <h1>Nous joindre</h1>
          <p className="page-lead">
            Une question sur Medcodes? Écrivez-nous et nous vous reviendrons
            dès que possible.
          </p>
        </header>

        {success ? (
          <div className="alert alert-success" role="alert">
            {success}
          </div>
        ) : (
          <>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="contact-honeypot" aria-hidden="true">
                <label htmlFor="company">Entreprise</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  tabIndex={-1}
                  autoComplete="off"
                />
              </div>

              <div className="form-group">
                <label htmlFor="name">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  maxLength={100}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Courriel</label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  maxLength={254}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  className="form-control contact-message"
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={4000}
                  rows={6}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary auth-actions-btn" disabled={loading}>
                {loading ? 'Envoi...' : 'Envoyer le message'}
              </button>
            </form>
          </>
        )}

        <footer className="legal-page-footer">
          <Link to="/" className="btn btn-outline-primary">Retour à l'accueil</Link>
        </footer>
      </article>
    </div>
  );
};

export default Contact;
